import { Types } from "../actions/EkedEquipmentActions";

const initialState = {
    ekedEquipmentList: {},
    isTaskUpdated: false,
    ekedEquipmentFiles: null,
    ekedEquipmentFilePreviews: null,
};

export const EkedEquipmentReducer = (state = initialState, action) => {
    switch (action.type) {
        case Types.SET_EKEDEQUIPMENTS:
            return {
                ...state,
                ekedEquipmentList: action.payload || state.ekedEquipmentList,
            };
        case Types.IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: true,
            };
        case Types.RESET_IS_UPDATED_TASK:
            return {
                ...state,
                isTaskUpdated: false,
            };
        case Types.SET_EKED_EQUIPMENT_FILES:
            return {
                ...state,
                ekedEquipmentFiles: action.payload || state.ekedEquipmentFiles,
            };
        case Types.SET_EKED_EQUIPMENT_FILE_PREVIEWS:
            return {
                ...state,
                ekedEquipmentFilePreviews: action.payload || state.ekedEquipmentFilePreviews,
            };

        default:
            return state;
    }
};
